import { useMemo } from "react";
import { useDispatch } from "react-redux";
import type { HistoricNarRecommendation } from "../../../../../../shared/api/services/historicNar/types";
import { ModalId } from "../../../../../../shared/enums/modalId";
import CustomTable from "../../../../../components/custom-table/custom-table";
import { HistoricNarIngestionState } from "../../../../../enums/historicNarIngestionState";
import { setOpenedModalId } from "../../../../../redux/slice/modalSlice";
import { AppDispatch } from "../../../../../redux/store/store";
import type { NarAgentGridOrgTab } from "../../narAgentGrid/hooks/useNarAgentGridOrgTabs";
import {
  generateHistoricNarConfigTableData,
  HistoricNarConfigTableHeaders,
} from "../utils/historicNarConfigTable";

interface HistoricNarConfigTableProps {
  apiData: HistoricNarRecommendation[];
  tableRef: React.RefObject<HTMLDivElement>;
  clientOptions: NarAgentGridOrgTab[];
  onSearchTextChange?: (text: string) => void;
  onRefresh?: () => void;
}

/** Historic NAR table whose action icon opens the Redux-coordinated workflow. */
const HistoricNarConfigTable = ({
  apiData,
  tableRef,
  onSearchTextChange,
  onRefresh,
  clientOptions,
}: HistoricNarConfigTableProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const tableData = useMemo(
    () => generateHistoricNarConfigTableData(apiData, clientOptions),
    [apiData, clientOptions],
  );

  return (
    <div
      ref={tableRef}
      className="historic-nar-config-table flex h-full flex-col overflow-auto"
    >
      <CustomTable
        tableHeaders={HistoricNarConfigTableHeaders}
        tableData={tableData}
        tableName="historicNarConfig"
        itemsPerPage={20}
        pagesPerView={4}
        count={tableData.length}
        totalCount={tableData.length}
        endIndexOfTable={() => {}}
        searchingText={(text: string) => onSearchTextChange?.(text)}
        placeholder="Search by drug name, J-code, or plan"
        hideSearchBar={false}
        isFetching={false}
        showExportButton={false}
        onExportButtonClick={() => {}}
        showInLineLoader={false}
        showRefreshButton
        onRefreshButton={() => onRefresh?.()}
        onIconCellClick={(data) =>
          dispatch(
            setOpenedModalId({
              id:
                data.status === HistoricNarIngestionState.NEEDS_REVIEW
                  ? ModalId.NEEDS_REVIEW_MODAL
                  : ModalId.HISTORIC_NAR_CONFIRM_SOURCE_MODAL,
              metaData: data,
            }),
          )
        }
      />
    </div>
  );
};

export default HistoricNarConfigTable;
